import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  addLastData,
  deleteLastData,
  getAllData,
  getLastData,
  getSpotData,
  pushLastData,
} from "../../api/apitools";
import { DeviceDataState ,SpotInfo, DeviceInfoData} from "deviceDataTypes";

const initialState: DeviceDataState = {
  deviceType: localStorage.getItem("device") || "inu",
  status: "idle",
  deviceInfoData: {
    prd_id: "",
    name: "",
    lat: 0,
    lng: 0,
    el: 404,
    extend_date: "",
    img1: "",
    img2: "",
    img3: "",
    owner: "",
    set_time: "",
    usim: "",
    spot_code: null,
    base: undefined,
    danger_value: undefined,
    attention_value: undefined,
  },
  deviceAllData: [],


  spotInfo: {
    dem_meter: "",
    id: "",
    lat: 0,
    lng: 0,
    location: "",
    spot_name: "",
  },
  spotInfoList:[],
};

export const getLastDeviceData = createAsyncThunk(
  "deviceData/fetchLastData",
  async ({ deviceType, prdId }: { deviceType: string; prdId: string }) => {
    const response = await getLastData(deviceType, prdId);
    // return {deviceinfo:response.data.data,spotinfo:response.data.data};
    console.log(response.data.data)
    return response.data.data;
  }
);


export const pushDeviceData = createAsyncThunk(
  "deviceData/fetchPushData",
  async ({
    deviceType,
    deviceInfoData,
  }: {
    deviceType: string;
    deviceInfoData: DeviceInfoData;
  }) => {
    const response = await pushLastData(deviceType, deviceInfoData!);
    return response.data.data;
  }
);
export const addDeviceData = createAsyncThunk(
  "deviceData/addData",
  async ({
    deviceType,
    deviceInfoData,
  }: {
    deviceType: string;
    deviceInfoData: DeviceInfoData;
  }) => {
    const response = await addLastData(deviceType, deviceInfoData);
    console.log(response);
    return response.data.data;
  }
);

export const deleteDeviceData = createAsyncThunk(
  "deviceData/deleteData",
  async ({
    deviceType,
    deviceInfoData,
  }: {
    deviceType: string;
    deviceInfoData: DeviceInfoData;
  }) => {
    const response = await deleteLastData(deviceType, deviceInfoData);
    return response.data.data;
  }
);

export const fetchAllDeviceData = createAsyncThunk(
  "deviceData/fetchAllData",
  async ({
    deviceType,
    search,
    searchType,
  }: {
    deviceType: string;
    search: string;
    searchType: "name" | "prd_id";
  }) => {
    const response = await getAllData(deviceType, search, searchType);
    return response.data.data;
  }
);
export const fetchAllSpotData = createAsyncThunk(
  "deviceData/detchAllSpot",
  async()=>{
    const response = await getSpotData('all');
    return response.data.data;
  }  
)



export const deviceDataSlice = createSlice({
  name: "deviceData",
  initialState,
  reducers: {
    userCheckInu: (state) => {
      state.deviceType = "inu";
      localStorage.setItem("device", "inu");
    },
    userCheckWal: (state) => {
      state.deviceType = "wal";
      localStorage.setItem("device", "wal");
    },
    setDeviceInfoData: (state, action) => {
      state.deviceInfoData = action.payload;
    },
    setSpotInfoData:(state,action)=>{
      state.spotInfo= action.payload;
    },
  },
  extraReducers(builder) {
    builder

        // getLastDeviceData
        .addCase(getLastDeviceData.pending, (state) => {
          state.status = "loading";
        })
        .addCase(getLastDeviceData.fulfilled, (state, action) => {
          state.status = "idle";
          state.deviceInfoData = action.payload.deviceinfo;
          state.spotInfo=action.payload.spotinfo;
        })
        .addCase(getLastDeviceData.rejected, (state, action) => {
          state.status = "failed";
          console.error("Error fetching data:", action.error.message);
          alert("에러가발행헀습니다.");
        })

        // pushDeviceData
        .addCase(pushDeviceData.pending, (state) => {
          state.status = "loading";
        })
        .addCase(pushDeviceData.fulfilled, (state, action) => {
          state.status = "idle";
          alert(action.payload);
        })
        .addCase(pushDeviceData.rejected, (state, action) => {
          state.status = "failed";
          console.error("Error pushing data:", action.error.message);
          alert("데이터를 push하는데 에러가 발생했습니다.");
        })


        // addDeviceData
        .addCase(addDeviceData.pending, (state) => {
          state.status = "loading";
        })
        .addCase(addDeviceData.fulfilled, (state, action) => {
          state.status = "idle";
          // Handle the response as needed, for simplicity, I'm just alerting the payload
          alert(action.payload);
        })
        .addCase(addDeviceData.rejected, (state, action) => {
          state.status = "failed";
          console.error("Error adding data:", action.error.message);
          alert("데이터를 추가하는데 에러가 발생했습니다.");
        })

        // deleteDeviceData
        .addCase(deleteDeviceData.pending, (state) => {
          state.status = "loading";
        })
        .addCase(deleteDeviceData.fulfilled, (state, action) => {
          state.status = "idle";
          alert(action.payload);
        })
        .addCase(deleteDeviceData.rejected, (state, action) => {
          state.status = "failed";
          console.error("Error deleting data:", action.error.message);
          alert("데이터를 삭제하는데 에러가 발생했습니다.");
        })

        // fetchAllDeviceData
        .addCase(fetchAllDeviceData.pending, (state) => {
          state.status = "loading";
        })
        .addCase(fetchAllDeviceData.fulfilled, (state, action) => {
          state.status = "idle";

          state.deviceAllData = action.payload;
        })
        .addCase(fetchAllDeviceData.rejected, (state, action) => {
          state.status = "failed";
          console.error("Error fetching all data:", action.error.message);
          alert("모든 데이터를 가져오는데 에러가 발생했습니다.");
        })

        // fetchAllSpotData
        .addCase(fetchAllSpotData.pending, (state) =>{
          state.status = "loading";
        })
        .addCase(fetchAllSpotData.fulfilled, (state, action) =>{
          state.status = "idle";
          state.spotInfoList = action.payload;
        })
        .addCase(fetchAllSpotData.rejected, (state, action) =>{
          state.status = "failed";
          console.error("Error fetching all data:", action.error.message);
          alert("모든 데이터를 가져오는데 에러가 발생했습니다.");
        })
  },
});

export const selectStatus = (state:RootState) => state.deviceData.status;
export const selectSpotInfoList = (state:RootState)=> state.deviceData.spotInfoList;
export const selectSpotInfo = (state:RootState)=> state.deviceData.spotInfo;
export const selectDeviceType = (state: RootState) =>
  state.deviceData.deviceType;
export const selectDeviceInfoData = (state: RootState) =>
  state.deviceData.deviceInfoData;
export const selectDeviceAllInfoData = (state: RootState) =>
// console.log("@#@#@#@#")
  state.deviceData.deviceAllData;
export const { userCheckInu, userCheckWal, setDeviceInfoData,setSpotInfoData } =
  deviceDataSlice.actions;

export default deviceDataSlice.reducer;
